import React, { useState } from 'react';
import './index.scss';

import { textContent } from '../../../types/data.global';
import SectionTitle from '../../SectionTitle';


// the three directions' names, shared with the Selected Research groups below (the bracket captions keep the short names)
export const DIRECTION_NAMES = ['HAI for Scientific Discovery', 'HAI for Decision-Making', 'Human–Agent Collaboration'];

// Research area, set like an editorial page: the section headline, thin rules, and the three
// themes as a row of greyscale images with bracket captions (the image turns to colour on hover).
// Each theme's question and background are folded away until "More" opens all three; its papers are listed under Selected Research.
const ResearchThemePage: React.FC = () => {
  const themes = textContent.researchThemePage;
  const [open, setOpen] = useState(false);
  // every column shares the same rows (image, caption, title, question, background),
  // so titles and questions line up across the three columns
  const rows = 5;

  return (
    <div className='research-theme-div-homepage ra' id='researchThemePage-homepage'>
      <div className='ra-hero'>
        <SectionTitle title={<>Seeing Science as a<br />Human⁠–⁠AI System</>} />
        <p className='ra-lede'>
            I design human–AI systems and visualizations that combine AI's efficiency and productivity with human expertise and judgment — to accelerate scientific discovery, to support high-stakes decisions about science and society, and to rethink how we work with data in the age of generative AI.
        </p>
      </div>

      <div className='ra-grid' id='researchThemePage'>
        {themes.map((item, index) => (
          <article key={index} id={`researchThemePage-${index}-${item.title}`} className='ra-item' style={{ gridRow: `span ${rows}` }}>
            <div className='ra-img'><img src={item.teaser} alt={item.title} loading='lazy' /></div>
            <p className='ra-cap'>[ 0{index + 1} · {item.title} ]</p>
            <h3 className='ra-title'>{DIRECTION_NAMES[index] || item.title}</h3>
            <p className='ra-q' hidden={!open}>{item.researchQuestion}</p>
            <div className='ra-intro' hidden={!open}><p>{item.introduction}</p></div>
          </article>
        ))}
      </div>
      <button type='button' className='ra-more' aria-expanded={open} aria-controls='researchThemePage' onClick={() => setOpen(o => !o)}>
        {open ? 'Less' : 'More'} <span aria-hidden='true'>{open ? '↑' : '↓'}</span>
      </button>
    </div>
  );
};

export default ResearchThemePage;
